export default __webpack_public_path__ + "images/e12a8e1ccf589d482f8292910398abfe-obstacles.jpg";